import React from 'react';
import './SegmentedControl.css';

/**
 * N-segment toggle control with sliding animation
 * @param {Array} segments - Array of { id, label, icon? }
 * @param {string} activeId - The id of the currently active segment
 * @param {function} onSelect - Handler called with segment id on click
 */
function SegmentedControl({ segments, activeId, onSelect }) {
  const activeIndex = segments.findIndex(s => s.id === activeId);

  return (
    <div
      className="segmentedControl"
      style={{
        '--segment-count': segments.length,
        '--active-index': activeIndex >= 0 ? activeIndex : 0,
      }}
    >
      <div className="segmentSlider" />

      {segments.map((segment, i) => (
        <button
          key={segment.id}
          className={`segmentButton ${segment.id === activeId ? 'active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(segment.id);
          }}
          style={
            i === 0 ? { borderTopLeftRadius: 7, borderBottomLeftRadius: 7 } :
            i === segments.length - 1 ? { borderTopRightRadius: 7, borderBottomRightRadius: 7 } :
            undefined
          }
        >
          {segment.icon}
          {segment.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
